export const airports = [
  {name: 'Bodö', abbreviation: 'BOO', latLng: {lat: 67.26822, lng: 14.36259}},
  {name: 'Mo i Rana', abbreviation: 'MQN', latLng: {lat: 66.36400, lng: 14.30292}},
  {name: 'Hemavan Tärnaby', abbreviation: 'HMV', latLng: {lat: 65.81199, lng: 15.07793}},
  {name: 'Storuman', abbreviation: 'SQO', latLng: {lat: 64.96072, lng: 17.69704}},
  {name: 'Lycksele', abbreviation: 'LYC', latLng: {lat: 64.55155, lng: 18.70764}},
  {name: 'Vilhelmina', abbreviation: 'VHM', latLng: {lat: 64.57919, lng: 16.83666}},
  {name: 'Arvidsjaur', abbreviation: 'AJR', latLng: {lat: 65.59497, lng: 19.26687}},
  {name: 'Luleå', abbreviation: 'LLA', latLng: {lat: 65.54293, lng: 22.12367}},
  {name: 'Skellefteå', abbreviation: 'SFT', latLng: {lat: 64.62575, lng: 21.06898}},
  {name: 'Umeå', abbreviation: 'UME', latLng: {lat: 63.79162, lng: 20.28378}},
  {name: 'Örnsköldsvik', abbreviation: 'OER', latLng: {lat: 63.40816, lng: 18.99159}},
  {name: 'Sundsvall', abbreviation: 'SDL', latLng: {lat: 62.52629, lng: 17.44551}},
  {name: 'Åre-Östersund', abbreviation: 'OSD', latLng: {lat: 63.19554, lng: 14.49453}},
  {name: 'Trondheim', abbreviation: 'TRD', latLng: {lat: 63.45804, lng: 10.92442}},
  {name: 'Vasa', abbreviation: 'VAA', latLng: {lat: 63.05059, lng: 21.76288}},
  {name: 'Kokkola', abbreviation: 'KOK', latLng: {lat: 63.72088, lng: 23.14389}},
  {name: 'Seinäjoki', abbreviation: 'SJY', latLng: {lat: 62.69352, lng: 22.82853}},
  {name: 'Oulu', abbreviation: 'OUL', latLng: {lat: 64.93013, lng: 25.35503}},
]

export const calculateDistance = (latLng1, latLng2) => {
  const earthRadius = 6371e3
  const phi1 = latLng1.lat * Math.PI/180
  const phi2 = latLng2.lat * Math.PI/180
  //const deltaPhi = (latLng2.lat - latLng1.lat) * Math.PI/180
  const deltaLambda = (latLng2.lng - latLng1.lng) * Math.PI/180

  const distance = Math.acos(Math.sin(phi1)*Math.sin(phi2) + Math.cos(phi1)*Math.cos(phi2)*Math.cos(deltaLambda)) * earthRadius

  return distance/1000
}